import React, { useState } from 'react';
import { useQuota } from '../context/QuotaContext';
import { FiX, FiChevronDown } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const QuotaModal = ({ onClose }) => {
  const { quota, updateQuota } = useQuota();
  const [formData, setFormData] = useState({
    amount: quota.amount,
    period: quota.period
  });

  const periods = ['monthly', 'quarterly', 'yearly'];

  const handleSubmit = (e) => {
    e.preventDefault();
    updateQuota({
      amount: parseFloat(formData.amount),
      period: formData.period,
      history: quota.history || []
    });
    onClose();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'amount' ? value : value
    }));
  };

  // Helper to format numbers with commas
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            Set Sales Quota
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            <SafeIcon icon={FiX} className="w-5 h-5 text-gray-500 dark:text-gray-400" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Quota Amount ($)
            </label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
              min="1"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Period
            </label>
            <div className="relative">
              <select
                name="period"
                value={formData.period}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none capitalize"
              >
                {periods.map(period => (
                  <option key={period} value={period} className="capitalize">{period}</option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <SafeIcon icon={FiChevronDown} className="w-4 h-4 text-gray-500 dark:text-gray-400" />
              </div>
            </div>
          </div>

          <div className="bg-blue-50 dark:bg-blue-900/30 p-4 rounded-lg border border-blue-100 dark:border-blue-800/50">
            <h3 className="text-sm font-medium text-blue-800 dark:text-blue-300 mb-2 text-center">Pipeline Goal (4x Quota)</h3>
            <div className="grid grid-cols-1 gap-2">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 dark:text-gray-400 capitalize text-center w-full">
                  {formData.period} Quota:
                </span>
                <span className="font-medium text-gray-900 dark:text-white">
                  ${formatNumber(formData.amount)}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-blue-600 dark:text-blue-400 font-medium capitalize text-center w-full">
                  {formData.period} Pipeline Goal:
                </span>
                <span className="font-bold text-blue-700 dark:text-blue-300">
                  ${formatNumber(formData.amount * 4)}
                </span>
              </div>
            </div>
          </div>

          <div className="flex space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Save Quota
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuotaModal;